import * as Dialog from '@radix-ui/react-dialog';
import { useT } from '../i18n';

export function ReleaseNotesDialog() {
  const t = useT();
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <button
          type="button"
          className="nv-version"
          title={`v${__APP_VERSION__} · ${__BUILD_TIME__}`}
          aria-label={`${t('releaseNotesOpen')} ${__APP_VERSION__}`}
        >
          v{__APP_VERSION__}
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[70] settings-overlay" />
        <Dialog.Content className="confirm-dialog fixed top-1/2 left-1/2 z-[71] w-[min(520px,calc(100vw-32px))] -translate-x-1/2 -translate-y-1/2 rounded-[14px] border p-5 shadow-[var(--shadow-popover)]">
          <Dialog.Title className="m-0 text-16 font-semibold text-text-primary">
            {t('releaseNotesTitle')} {__APP_VERSION__}
          </Dialog.Title>
          <Dialog.Description className="mt-1 mb-4 text-13 text-text-secondary">
            {t('releaseNotesIntro')}
          </Dialog.Description>
          {__RELEASE_NOTES__.length > 0 ? (
            <ul className="m-0 space-y-2 pl-5 text-14 leading-6 text-text-primary">
              {__RELEASE_NOTES__.map((note) => (
                <li key={note}>{note}</li>
              ))}
            </ul>
          ) : (
            <p className="m-0 text-14 text-text-secondary">{t('releaseNotesEmpty')}</p>
          )}
          <div className="mt-5 flex justify-end">
            <Dialog.Close className="btn-secondary">{t('close')}</Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
